import { createAction } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';

import type { Pipe } from 'src/types/pipes.types';
import type { InternalEntities } from 'src/types/state.types';
import type { System } from 'src/types/system.types';
import type { Dataset } from 'src/types/dataset.types';

export const setInternalPipes = createAction<Pipe[]>('internalEntities/setPipes');
export const setInternalSystems = createAction<System[]>('internalEntities/setSystems');
export const setInternalDatasets = createAction<Dataset[]>('internalEntities/setDatasets');

const initialState: InternalEntities = {
  pipes: [],
  systems: [],
  datasets: [],
};

export const internalEntitiesReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(setInternalPipes, (state, action) => {
      state.pipes = action?.payload;
    })
    .addCase(setInternalSystems, (state, action) => {
      state.systems = action?.payload;
    })
    .addCase(setInternalDatasets, (state, action) => {
      state.datasets = action?.payload;
    })
);
